import React from "react";

export const TopThinBanner = () => {
  return (
    <div className="text-secondary bg-primary font-bodyCopy text-xs md:text-md py-2">
      SUBSCRIBE AND SAVE | FREE SHIPPING TO 43 STATES
    </div>
  );
};
